import type { NavigationAdapter } from '../types';

export const webNavigation: NavigationAdapter = {
  readHash: () => location.hash,
  writeHash: (hash: string) => history.replaceState(null, '', hash)
};
